import tools from "../../adScripts/adTools"



const STR_NAME = "mabe";
const STR_TOKEN = "6D395158HUKHU3HU4HK34UN685D198499A876"
const STR_CURRENT_PAGE = "6D395158HUKHU3HU4HK34UN685D198499FNDKGVU34UNKA876"
const STR_NEXT_RUTE_PAGE = "6D395158HUKHU3HU4HK34UN685D1984JNILKOKSÑACOOFÑ99FNDKGVU34UNKA876"
const STR_INDEX_QUESTION = "12ABCD34EFGHIJK5678LMNOPQ90RSTUVWXYZ12345678"
const STR_INDEX_EVAL = "12ABCD34EFGHIJK5678LMNOPQ90RSTUVWXYZHKSEFNFL238O12345678"
const STR_MODEL = "686484jh34khhkK34UN685D198499FNDKGVU34UNKA876"
export const STR_PERMISSION = "d5d43d4B16JNU34H3IUUK3NK5N3Kaa22ef47a"


const state = {
    token: tools.getCookie(STR_TOKEN) || null,
    name: sessionStorage.getItem(STR_NAME) || 'Mabe',
    nextRute: sessionStorage.getItem(STR_NEXT_RUTE_PAGE) || '/',
    page: sessionStorage.getItem(STR_CURRENT_PAGE) || '/',
    model: JSON.parse(sessionStorage.getItem(STR_MODEL)) || {},
    currentEval: JSON.parse(sessionStorage.getItem(STR_INDEX_EVAL)) || {},
    indexQuestion: sessionStorage.getItem(STR_INDEX_QUESTION) || 0,
    selectedMinus: [],
    selectedPlus: [],
}
const getters = {
   
    isValid: state => {
        if (state.token != null) {
            return state.token.split('.').length === 3;
        }
        return false;
    },
    token: state => state.token,
    page: state => state.page,
    getInstructions: state => state.nextRute,
    getModel: state => state.model,
    name: state => {
        if(state.name == null || state.name == 'Mabe'){
            window.location.href = '/'
        }
        return state.name
    },
    indexQuestion:state => state.indexQuestion,
    currentEval:state => state.currentEval,
    selectedMinus:state =>state.selectedMinus,
    selectedPlus:state=>state.selectedPlus
}
const mutations = {
    setToken: (state, data) => {
        state.token = data.token
        tools.setCookie(STR_TOKEN, data.token)
    },
    setModel: (state, model) => {
        sessionStorage.setItem(STR_CURRENT_PAGE, model.path)
        sessionStorage.setItem(STR_MODEL, JSON.stringify(model))
        //let t = JSON.parse(sessionStorage.getItem(STR_MODEL))
        state.page = model.path
        state.model = model
    },
    setInstructions: (state, rute) => {
        sessionStorage.setItem(STR_NEXT_RUTE_PAGE, rute)
        state.nextRute = rute        
    },
    setName: (state, name) => {
        sessionStorage.setItem(STR_NAME, name)
        state.name = name
    },
   
    logout(state){
        tools.setCookie(STR_TOKEN, null)
        sessionStorage.removeItem(STR_NAME)
        state.token = null
        state.name = 'Mabe'
    },
    setIndexQuestion: (state, index) =>{
        sessionStorage.setItem(STR_INDEX_QUESTION, index)
        state.indexQuestion = index
    },
    setIndexQuestionPage: (state, index) =>{
        let m =  state.model
        if(m != null){
            m.indexQuestion = index
        }
        state.model = m
        state.indexQuestion = index
        sessionStorage.setItem(STR_CURRENT_PAGE, m.path)
        sessionStorage.setItem(STR_MODEL, JSON.stringify(m))
    },
    setResetSelectedMinus(state) {state.selectedMinus = [];},
    setResetSelectedPlus(state) {state.selectedPlus = [];},
}
const actions = {
    setToken: (context, data) => { context.commit('setToken', data) },
    setModel: (context, model) => { context.commit('setModel', model) },
    setInstructions: (context, rute) => { context.commit('setInstructions', rute) },
    logout(context){
        context.commit("logout")
    },
    setIndexQuestion:(context, index)=>{context.commit('setIndexQuestion', index)},
    setIndexQuestionPage:(context, index)=>{context.commit('setIndexQuestionPage', index)},
    setResetSelectedMinus(context) {context.commit('setResetSelectedMinus');},
    setResetSelectedPlus(context){context.commit('setResetSelectedPlus');},
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}